import React, { useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import ProgressBar from '../../../utils/progressBar/ProgressBar.js';
import { addInvoices } from '../../../redux/api/invoicesApi/invoicesApi.js';
import { addinvoicesAction } from '../../../redux/reduxSlice/InvoicesSlice.js';
import { updateInvoices } from '../../../redux/api/invoicesApi/invoicesApi.js';
import { updateinvoicesAction } from '../../../redux/reduxSlice/InvoicesSlice.js';
import { Drawer, DrawerBody, DrawerFooter, DrawerHeader, DrawerOverlay, DrawerContent, DrawerCloseButton, FormLabel, Textarea } from '@chakra-ui/react';
import Select from 'react-select';
import { Option, Trash2,Plus } from 'lucide-react';
import QuoteInventoryForm from '../../crm/proposal/QuoteInventoryForm.js';
import './Invoice.css';
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Checkbox,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Spinner,
  Button,
  ModalCloseButton
} from '@chakra-ui/react'
import { getInventory } from '../../../redux/reduxApi/inventoryReduxApi.js';
import { getClient } from '../../../redux/reduxApi/clientReduxApi.js';

const initialFormData1 = {
  customerName:null,
  invoice: "",
  orderNumber: "",
  workingDays: "",
  paymentTerms: "",
  franchiseeAccount: "",
  frequency: "",
  salesPerson: "",
  dueDate: "",
  invoiceDate: "",
  jobType: "",
  soDate: "",
  customerNotes: "",
  items: [],
  termsConditions: ""
}
function InvoiceForm(props) {
  const { isUpdateMode, dataToEdit, formData: initialFormData, setIsUpdateMode, invoicesId, onNewDataAdded } = props;
  const dispatch = useDispatch();
  const [showProgressBar, setShowProgressBar] = useState(false);
  const [submitDisabled, setSubmitDisabled] = useState(false);
  const [deletedItemRows, setDeletedItemRows] = useState([]);
  const [inventoryOptions, setInventoryOptions] = useState([]);
  const [formData, setFormData] = useState(initialFormData1);
  const inventoryData = useSelector((state) => state?.inventory?.inventory);
  const [clientOptions, setClientOptions] = useState([]);
  const [clientsData, setClientsData] = useState(initialFormData1);
  const clientData = useSelector((state) => state?.client?.client);
  const quoteList = useSelector((state) => state.utils.quoteList.map((item) => ({ ...item, label: item?.name, value: item?.rowId })));
  const [item, setItem] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);


  useEffect(() => {
    dispatch(getClient(1))
      .catch((error) => {
        console.error("Error fetching getClient data:", error);
      })
      .finally(() => { });
  }, [dispatch]);


  useEffect(() => {
    if (Array.isArray(clientData)) {
      const temp = clientData.map(({ clients }) => {
        if (clients && clients.ROWID && clients.firstName) {
          return {
            value: clients.ROWID,
            label: clients.firstName,
            ...clients,
          };
        }
        return null; // Return null if client data is missing
      }).filter(option => option !== null);

      setClientOptions(temp);
    }
  }, [clientData]);

  // Updating table row data with selected client
  const setDataToItemTableRowClient = (option) => {
    if (!option) return; // If option is null or undefined, don't update

    setRows((prevRows) =>
      prevRows.map((row, idx) =>
        row.index === option.index // Ensure you're updating the correct row by index
          ? {
            ...row,
            clientData: option.label || '', // Use `label` from select option
            rowId: option.ROWID || '', // Use `ROWID` from select option
          }
          : row
      )
    );
  };


  useEffect(() => {
    dispatch(getInventory(1))
      .catch((error) => {
        console.error('Error fetching Inventory data:', error);
      });
  }, [dispatch]);

  // Update inventory options when inventoryData changes
  useEffect(() => {
    if (Array.isArray(inventoryData)) {
      const temp = inventoryData?.map(({ inventory }) => ({
        value: inventory?.ROWID,
        label: inventory?.name,
        ...inventory,
      }));
      setInventoryOptions(temp); // Update inventory options
    }
  }, [inventoryData]);

  // Updating row data based on selected item
  const setDataToItemTableRow = (item, index) => {
    if (!item) return;

    setRows((prev) =>
      prev.map((row, idx) =>
        idx === index
          ? {
              ...row,
              inventoryData: item.label || '',
              rowId: item.ROWID || '',
              annualQty: item.annualQty || 0,
              annualContractvalue: item.annualContractValue || 0,
              servPClean: item.servPClean || '',
              qty: item.annualQty || 0,
              rate: item.sellingPrice || 0,
              tax: item.tax || 0,
            }
          : row
      )
    );

    // Updating formData after modifying rows
    setFormData((prev) => ({
      ...prev,
      itemtable: [...rows], // Ensure itemtable is updated with the latest row data
    }));
  };

  const calculateAmount = (qty, rate, discount) => {
    return qty * rate * (1 - discount / 100);
  };

  const calculateTotal = (amount, tax) => {
    return amount * (1 + tax / 100);
  };

  // Delete row function
  const deleteRow = (index) => {
    setRows((prev) => prev.filter((_, idx) => idx !== index));
    setFormData((prev) => ({ ...prev, itemtable: rows.filter((_, idx) => idx !== index) }));
  };

  const handleOnClose = () => {
    closeDrawer();
    setIsUpdateMode(false)
    setFormData(initialFormData1)
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setShowProgressBar(true)
    addInvoices(formData)
      .then((response) => {
        onNewDataAdded()
        if (response.data.success) {
          const ROWID = response.data.ROWID
          dispatch(addinvoicesAction({ ROWID, formData }));
          console.log(response)
          setFormData()
          setShowProgressBar(false)
          toast.success("Invoice added successfully!");
          handleOnClose();
          setFormData();
        }
        else {
          toast.error("Unable to add Invoice , Please try again!")
        }
      })
      .catch((error) => {
        console.error("API Error", error);
        setShowProgressBar(false)
        toast.error("Failed to add Invoice. Please try again.");
      });
  }
  const handelOnUpdate = (e) => {
    e.preventDefault();
    setShowProgressBar(true);
    updateInvoices(formData, invoicesId).then((response) => {
      console.log({ response })
      toast.success("Invoices Updated successfully!");
      handleOnClose();
      if (response.data.success) {
        dispatch(updateinvoicesAction({ formData, invoicesId }))
      }
    }).catch((error) => {
      setShowProgressBar(false);
      console.log({ error })
    }).finally(() => {
      setShowProgressBar(false);
    })
  };

  // UpdateMode Use-effect
  useEffect(() => {
    console.log({ isUpdateMode }, { dataToEdit })
    if (isUpdateMode && dataToEdit) {
      setFormData((prev) => ({
        ...prev, ...props.dataToEdit,
        itemtable: dataToEdit.items ? [...JSON.parse(dataToEdit.items)] : []
      }
      ))
    }
    console.log(formData)
    if (dataToEdit.items) {
      setRows(JSON.parse(dataToEdit.items))

    }
  }, [isUpdateMode, dataToEdit]);

  const editId = useMemo(() => {
    return props.editId;
  }, [JSON.stringify(props.editId)]);

  const handleOnChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setFormData(prev => ({ ...prev, [name]: value }))
  };

  const addRow = (e) => {
    e.preventDefault()
    const newRows = [...rows, { itemDetail: '', annualQty: '', servepClean: '', qty: "", rate: "", annualContractvalue: "", tax: '', amount: "", total: '', subTotal: '', discount:'' }];
    setRows(newRows);
    setFormData(prev => ({ ...prev, itemtable: newRows }));
  };



  // Custom style for lookup field
  const customStyle = {
    control: (baseStyles, state) => ({
      ...baseStyles,
      borderColor: state.isFocused ? 'silver' : 'rgb(93, 135, 255)',
      borderRadius: "10px",
      border: '0.5px solid rgb(196,196,196,0.5) !important',
    }),
    placeholder: (styles) => ({
      ...styles,
      color: 'gray',
    }),
    singleValue: (styles, { data }) => ({
      ...styles,
      color: 'black',
      backgroundColor: 'white',
    }),
    option: (styles, { isSelected, isFocused }) => ({
      ...styles,
      backgroundColor: isSelected
        ? '#f1e9e9;'
        : isFocused
          ? '#f1e9e9;'
          : 'white',
      color: isSelected ? '#666' : '#333',
    }),
  }

  const { closeDrawer } = props;

  const [rows, setRows] = useState([
    { itemDetail: '', annualQty: '', servepClean: '', qty: "", rate: "", annualContractvalue: "", tax: '', amount: "", total: '', subTotal: '' }
  ]);

  const handleChange = (e, index = null, field = null) => {
    const { name, value } = e.target;
    if (index !== null && field !== null) {
      let newRows = [...rows];
      newRows[index][field] = value;

      if (field === 'qty' || field === 'rate' || field === 'tax') {
        let qty = parseFloat(newRows[index].qty) || 0;
        let rate = parseFloat(newRows[index].rate) || 0;
        let tax = parseFloat(newRows[index].tax) || 0;

        // Calculate amount (excluding tax)
        newRows[index].amount = qty * rate;

        // Calculate tax amount for the row

        newRows[index].taxAmount = (qty * rate * tax) / 100;
      }
      setRows(newRows);
    } else {
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };
  useEffect(() => {
    console.log({ formData })
  }, [formData])

  const subtotal = rows.reduce((sum, row) => sum + (parseFloat(row.amount) || 0), 0).toFixed(2);

    // // Calculate total tax
  const totalTax = rows.reduce((sum, row) => sum + (parseFloat(row.taxAmount) || 0), 0).toFixed(2);

  // // Calculate grand total (subtotal + totalTax)
   const grandTotal = (parseFloat(subtotal) + parseFloat(totalTax)).toFixed(2);




    // Map of tax percentages to tax names
    const taxOptions = {
      "GST0 [0%]": "GST0 [0%]",
      "GST5 [5%]": "GST5 [5%]",
      "GST12 [12%]": "GST12 [12%]",
      "GST18 [18%]": "GST18 [18%]",
      "GST28 [28%]": "GST28 [28%]",
      "GST14 [28%]": "GST14 [28%]",
      "GST9 [18%]": "GST9 [18%]",
      "Non Taxable": "Non Taxable",
      "Out of Scope": "Out of Scope",
      "Non GST Apply": "Non GST Apply",
    };
  
    // Helper function to get tax name by value
    const getTaxName = (taxValue) => {
      return taxOptions[taxValue] || "Select";
    };
    const getTaxDetails = (rows) => {
      // Group taxes by tax percentage and calculate total tax for each percentage
      const taxMap = rows.reduce((acc, row) => {
        const taxPercentage = parseFloat(row.tax) || 0;
        const rowSubtotal = (row.qty || 0) * (row.rate || 0);
        const taxAmount = (rowSubtotal * taxPercentage) / 100;  
  
        if (taxAmount > 0) {
          // Add the tax amount to the existing tax percentage group, or create a new group
          if (acc[taxPercentage]) {
            acc[taxPercentage] += taxAmount;
          } else {
            acc[taxPercentage] = taxAmount;
          }
        }
        return acc;
      }, {});
  
      // Convert the tax map into an array of strings in the required format
      const taxDetails = Object.keys(taxMap).map((taxPercentage) => {
        const totalTax = taxMap[taxPercentage].toFixed(2);
        return `${taxPercentage}% (₹${totalTax})`;
      });
  
      // Return all tax details as a single line, joined by a comma
      return taxDetails.join('\n');
    };


    const calculateGrandTotal = () => {
      const subtotal = rows.reduce(
        (total, row) => total + (row.qty || 0) * (row.rate || 0),
        0
      );
      const totalTax = rows.reduce((total, row) => {
        const taxPercentage = parseFloat(row.tax) || 0;
        const rowSubtotal = (row.qty || 0) * (row.rate || 0);
        const taxAmount = (rowSubtotal * taxPercentage) / 100;
        return total + taxAmount;
      }, 0);
      return subtotal + totalTax; // Grand total = subtotal + total tax
    };
  
    <p><b>Total:</b> {calculateGrandTotal().toFixed(2)}</p>;

  const itemData = useMemo(() => {
    return quoteList
  }, [JSON.stringify(quoteList)]);

  useEffect(() => {
    setItem(itemData);
  }, [itemData]);

  useEffect(() => {
    if (itemData && itemData.length > 0) {
      setSelectedItem(itemData[0]);
    }
  }, [itemData]);


  const [isDrawerOpenItem, setisDrawerOpenItem] = useState(false);
  const openDrawerItem = () => {
    setisDrawerOpenItem(true);
  };
  const closeDrawerItem = () => {
    setisDrawerOpenItem(false);
  };
  const itemComponent = {
    MenuList: (props) => (
      <div style={{ position: 'relative' }}>
        <div {...props.innerProps} className="custom-menu-list"
          style={{
            maxHeight: '130px',
            overflowY: 'auto',
            paddingBottom: '40px',
          }}>
          {props.children}
        </div>
        <div className="add-new-option"
          style={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            backgroundColor: '#fff',
            borderTop: '1px solid #ddd',
            padding: '3px',
            textAlign: 'center',
          }}
        >
          <button
            type="button"
            className="btn btn-link d-flex align-items-center"
            onClick={setisDrawerOpenItem}
            style={{ textDecoration: "none" }}
          >
            Add New Item<Plus size={14} />
          </button>
        </div>
      </div>
    ),
  };


  
    const customComponents = {
      MenuList: (props) => (
        <div style={{ position: "relative" }}>
          <div
            {...props.innerProps}
            className="custom-menu-list"
            style={{
              maxHeight: "200px",
              overflowY: "auto",
              paddingBottom: "40px",
            }}
          >
            {props.children}
          </div>
          <div
            className="add-new-option"
            style={{
              position: "absolute",
              bottom: 0,
              left: 0,
              right: 0,
              backgroundColor: "#fff",
              borderTop: "1px solid #ddd",
              padding: "3px",
              textAlign: "center",
            }}
          >
           
          </div>
        </div>
      ),
    };

    const userList = useSelector((state) => state.utils.userList);
  const [user, setUser] = useState([]);
    const userData = useMemo(() => {
      return userList.map((item) => ({
        label: item.employees.employeeName,
        value: item.employees.ROWID
      }))
    }, [JSON.stringify(userList)])
  
    useEffect(() => {
      setUser(userData);
    }, [userData])



  return (
    <>

          <Modal
            isOpen={isDrawerOpenItem}
            onClose={closeDrawerItem}
            size="xl"
            scrollBehavior="inside"
          >
            <ModalOverlay />
            <ModalContent>
              <ModalHeader>Create New Item</ModalHeader>
              <ModalCloseButton />
              <ModalBody
              >
                <QuoteInventoryForm closeDrawer={closeDrawerItem} />
              </ModalBody>
            </ModalContent>
          </Modal>

      <Drawer
        isOpen={props.isDrawerOpen}
        placement='right'
        size='xl'
        onClose={handleOnClose}
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader>
            {isUpdateMode ? "Update Invoice" : "Create Invoice"}

            </DrawerHeader>
          <DrawerBody>
            {showProgressBar && <ProgressBar colorScheme='pink' />}
            <form onSubmit={isUpdateMode ? handelOnUpdate : handleSubmit} >
            <div className='card'>
            <div className='card-body'>
              <div className='row '>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <Select
                    name='customerName'
                    options={clientOptions}
                    defaultValue={clientOptions.find((item) => item.value === clientData?.clientOptions)} 
                    value={clientOptions.find((item) => item.value === formData?.customerName)} 
                    onChange={(selectedOption) => {
                      setDataToItemTableRowClient(selectedOption);
                      setFormData((prevFormData) => ({
                        ...prevFormData,
                        clientOptions: selectedOption ? selectedOption.value : null,
                        customerName: selectedOption ? selectedOption.value : null, 
                      }));
                    }} styles={customStyle} 
                  />
                  <FormLabel className="small-label ps-3" style={{ paddingLeft: "2px" }}>Customer Name</FormLabel>
                </div>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <div className='search-by-title'>
                    <input type='text' style={{ outline: "none", border: "none" }} placeholder='Invoice' name='invoice' value={formData?.invoice} onChange={handleChange} />
                  </div>
                  <FormLabel className="small-label ps-3" style={{ paddingLeft: "2px" }}>Invoice Number</FormLabel>
                </div>
              </div>
              <div className='row '>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <div className='search-by-title'>
                    <input type='number' style={{ outline: "none", border: "none" }} placeholder='Order Number' name='orderNumber' value={formData?.orderNumber} onChange={handleChange} />
                  </div>
                  <FormLabel className="small-label ps-3" style={{ paddingLeft: "2px" }}>Quote Number</FormLabel>
                </div>

                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <div className='search-by-title'>
                    <select name='workingDays' type='text' placeholder="Working Days" style={{ width: '100%', outline: 'none' }} value={formData?.workingDays} onChange={handleChange}  >
                      <option >Monday</option>
                      <option >Tuesday</option>
                      <option >Wednesday</option>
                      <option >Thrusday</option>
                      <option >Friday</option>
                      <option >Saturday</option>
                      <option >Sunday</option>
                    </select>
                  </div>
                  <FormLabel className="small-label ps-3">Working Days</FormLabel>
                </div>
                
              </div>
              <div className='row '>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <div className='search-by-title'>
                    <select name='paymentTerms' type='text' placeholder="Payment Terms" style={{ width: '100%', outline: "none" }} value={formData?.paymentTerms} onChange={handleChange}  >
                      <option >Due On Receipt</option>
                      <option >Net 15</option>
                      <option >Net 30</option>
                      <option >Net 7</option>
                      <option >Net 60</option>
                      <option >Due end of the month</option>
                      <option >Due end of the next month</option>
                      <option >Custom</option>
                    </select>
                  </div>
                  <FormLabel className="small-label ps-3">Payment Terms</FormLabel>
                </div>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <Select
                      name="salesPerson"
                      options={user}
                      defaultValue={user.find((item) => item.value === formData?.salesPerson)}
                      onChange={(option) => {
                        setFormData((prevFormData) => ({ ...prevFormData, salesPerson: option.value }));
                      }}
                      styles={{
                        ...customStyle,
                        menu: (provided) => ({
                          ...provided,
                          maxHeight: 200, // Limit the dropdown height (adjust as needed)
                          overflowY: "auto", // Enable scrolling
                        }),
                      }}
                      components={customComponents}
                    />
                  <FormLabel className="small-label ps-3" style={{ paddingLeft: "2px" }}>Sales Person</FormLabel>
                </div>
              </div>
              <div className='row '>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <div className='search-by-title'>
                    <input type='text' style={{ outline: "none", border: "none" }} placeholder='franchisee Account' name='franchiseeAccount' value={formData?.franchiseeAccount} onChange={handleChange} />
                  </div>
                  <FormLabel className="small-label ps-3" style={{ paddingLeft: "2px" }}>Franchisee Account</FormLabel>
                </div>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <div className='search-by-title'>
                    <input type='date' style={{ outline: "none", border: "none" }} placeholder='Due Date' name='dueDate' value={formData?.dueDate} onChange={handleChange} />
                  </div>
                  <FormLabel className="small-label ps-3" style={{ paddingLeft: "2px" }}>Due Date</FormLabel>
                </div>
              </div>
              <div className='row '>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <div className='search-by-title'>
                    <select name='frequency' type='text' placeholder="Frequency" style={{ width: '100%', outline: 'none' }} value={formData?.frequency} onChange={handleChange}  >
                      <option>Weekly</option>
                      <option>Monthly</option>
                      <option>Fornightly</option>
                      <option>one-off job</option>
                    </select>
                  </div>
                  <FormLabel className="small-label ps-3">Frequency</FormLabel>
                </div>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <div className='search-by-title'>
                    <input className='rounded' type='date' style={{ outline: "none", border: "none" }} placeholder='Invoice Date' name='invoiceDate' value={formData?.invoiceDate} onChange={handleChange} />
                  </div>
                  <FormLabel className="small-label ps-3" style={{ paddingLeft: "2px" }}>Invoice Date</FormLabel>
                </div>
              </div>
              <div className='row '>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <div className='search-by-title'>
                    <select className=' rounded' name='jobType' type='text' placeholder="Job Type" style={{ width: '100%', outline: "none" }} value={formData?.jobType} onChange={handleChange}  >
                      <option >Regular</option>
                      <option >one-off job</option>
                    </select>
                  </div>
                  <FormLabel className="small-label ps-3">Job Type</FormLabel>
                </div>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <div className='search-by-title'>
                    <input className='rounded' type='date' style={{ outline: "none", border: "none" }} placeholder='So Date' name='soDate' value={formData?.soDate} onChange={handleChange} />
                  </div>
                  <FormLabel className="small-label ps-3" style={{ paddingLeft: "2px" }} >S/O Date</FormLabel>
                </div>
              </div>
              <div>
              </div>
            </div>
            </div>




              <div className='card mt-2'>
                <div className='card-body'>
              <div className='w-100'>
              <div className='custom-scroll'>
                <table className='table-class' style={{ paddingBottom: '50px' }}>
                  <thead>
                    <tr>
                      <th colSpan={9}>
                        <h5 style={{ fontSize: '15px' }}>Item Table</h5>
                      </th>
                    </tr>
                    <tr className='border'>
                      <th className='border' style={{ textAlign: 'center', fontWeight: '500' }}>ACTION</th>
                      <th className='border' style={{ textAlign: 'center', fontWeight: '500' }}>ITEM DETAILS</th>
                      <th className='border' style={{ textAlign: 'center', fontWeight: '500' }}>QTY</th>
                      <th className='border' style={{ textAlign: 'center', fontWeight: '500' }}>RATE</th>
                      <th className='border' style={{ textAlign: 'center', fontWeight: '500' }}>TAX</th>
                      <th className='border' style={{ textAlign: 'center', fontWeight: '500' }}>AMOUNT</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rows.map((row, index) =>
                     (
                      <tr key={index}>
                        <td className='border text-center table-class'>
                          <button onClick={() => deleteRow(index)} className='delete-button'>
                            <Trash2 size={16} color='#dd0b58' />
                          </button>
                        </td>

                        <td className='border table-class'>
                          <Select
                            name='inventoryData'
                            options={itemData}
                            defaultValue={
                              row.inventoryData
                                ? itemData.find((item) => item.label === row.inventoryData)
                                : null
                            }
                            onChange={(option) => setDataToItemTableRow(option, index)}
                            className='custom-select-container'
                            classNamePrefix='custom-select'
                            components={itemComponent}
                          />
                        </td>

                        <td className='border table-class'>
                          <input
                            style={{ outline: 'none' }}
                            type='number'
                            value={row.qty || ''}
                            onChange={(e) => handleChange(e, index, 'qty')}
                          />
                        </td>

                        <td className='border table-class'>
                          <input
                            style={{ outline: 'none' }}
                            type='number'
                            value={row.rate || ''}
                            onChange={(e) => handleChange(e, index, 'rate')}
                          />
                        </td>

                        <td className='border table-class'>
                          <div style={{ width: '10rem' }}>
                            <select
                              name='tax'
                              value={row.tax || ''}
                              onChange={(e) => handleChange(e, index, 'tax')}
                              className='custom-select-container'
                              classNamePrefix='custom-select'
                            >
                              <option value='' disabled>Select</option>
                              <option value='0'>Non Taxable</option>
                              <option value='Out of Scope' title="Supplies on which you don't charge any GST or include them in the returns">
                                Out of Scope
                              </option>
                              <option value='Non GST Apply' title='Supplies on which do not come under GST'>
                                Non-GST Apply
                              </option>
                              <option value='GST0 [0%]'>GST0 [0%]</option>
                              <option value='5%'>GST5 [5%]</option>
                              <option value='12%'>GST12 [12%]</option>
                              <option value='18%'>GST18 [18%]</option>
                              <option value='28%'>GST28 [28%]</option>
                            </select>
                          </div>
                        </td>

                        <td className='border table-class'>
                          <input
                            style={{ outline: 'none' }}
                            type='text'
                            value={row.amount || ''}
                            readOnly
                          />
                        </td>
                      </tr>
                    ))}
                    <tr>
                      <td colSpan={9}>
                        <div className='ps-4' onClick={addRow} style={{ textAlign: 'left' }}>
                          <button type='text' style={{ outline: 'none' }}>
                            + Add row
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              {/* Summary Section */}
              <div className="row">
                <div className="d-flex justify-content-end align-items-center w-100">
                  <div className="card mt-3" style={{ width: "50%", borderRadius: "6px" }}>
                    <div className="card-body">

                      {/* Sub Total Section */}
                      <div className="row">
                        <div className="col-lg-6">
                          <p><b>Sub Total</b></p>
                        </div>
                        <div className="col-lg-6 text-end">
                          <p><b>{subtotal}</b></p>
                        </div>
                      </div>
                      {/* Tax Section */}
                      <div className="row" style={{ borderTop: "1px solid #e5e5e5" }}>
                        <div className="col">Tax: </div>
                        <div className="col text-end"> <pre><b> {getTaxDetails(rows)}</b></pre></div>
                      </div>
                      <div className="row mt-2" style={{ borderTop: "1px solid #e5e5e5" }}>
                        <div className="col-lg-6 mt-2">
                          <p><b>Total</b></p>
                        </div>
                        <div className="col-lg-6 text-end mt-2">
                          <p><b>{grandTotal}</b></p>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>

            </div>
            </div>
            </div>
            </form>
            <div className='card mt-2'>
                <div className='card-body'>
            <div className='row mt-3 mb-2'>
              <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                <Textarea type='text' style={{ border: "1px solid grey" }} placeholder='Looking forward to your business' name='customerNotes' value={formData?.customerNotes} onChange={handleChange} />
                <FormLabel className="small-label ps-3">Customer Notes</FormLabel>
              </div>
              <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                <Textarea type='text' style={{ border: "1px solid grey" }} placeholder='Terms & Conditions' name='termsConditions' value={formData?.termsConditions} onChange={handleChange} />
                <FormLabel className="small-label ps-3">Terms & Conditions</FormLabel>
              </div>
            </div>
            <div className='row justify-content-center '>
              <div className=' col-lg-12 mb-2 '>
                <label htmlFor="imageUpload" className="image-upload" style={{ border: '2px dashed lightgrey', borderRadius: '10px', width: '100%', height: '100px', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                  <div className='w-50 mx-auto'>
                    <input className='form-control' type="file" id="imageUpload" name="image" multiple />
                    <div className="image-upload-content" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                      <i className="fas fa-cloud-upload-alt" style={{ fontSize: '24px', marginBottom: '5px' }}></i>
                    </div>
                  </div>
                </label>
                <FormLabel className="small-label ps-3">Add Attachements</FormLabel>
              </div>
            </div>
            </div>
            </div>
          </DrawerBody>
          <center><DrawerFooter style={{ display: 'inline-block' }} >
            <div className='gap-3 d-flex'>
              <button variant='outline' mr={3} onClick={handleOnClose} className="cancel-button">
                Cancel
              </button>
              <button className='create-button' onClick={(e) => { !isUpdateMode ? handleSubmit(e) : handelOnUpdate(e) }} >{isUpdateMode ? "Update" : "Submit"}</button>
            </div>
          </DrawerFooter></center>
        </DrawerContent>
      </Drawer>
    </>
  )
}
export default InvoiceForm;